import React, { Fragment } from "react"
import {  FormLabel, LabelWrapper } from "./inputtextStyle";
import { InputTextarea  } from 'primereact/inputtextarea';
import PropTypes from 'prop-types';

function FormInputDescription({ label, name, type, value, required, onChange, ...rest }) {
    return (<Fragment>
        <LabelWrapper>
            <FormLabel>{label}{" "}
            {required?<span
                style={{
                  color: "#f10000",
                }}
              >
                *
              </span>:""}
              </FormLabel>
        </LabelWrapper>

        <InputTextarea 
            name={name}
            type={type}
            placeholder={"Enter " + label}
            value={value}
            onChange={(e) => onChange(e)}
            required={required}
            variant="filled"
            {...rest}
           
            
        />
    </Fragment>)
}
FormInputDescription.propTypes = {
    lable: PropTypes.string, // Add this line
    name:PropTypes.string,
    type:PropTypes.string,
    value:PropTypes.object,
    required:PropTypes.bool,
    onChange:PropTypes.func,
};
export default FormInputDescription;